import React from 'react'
import './lowvision.css'; // Don't forget to import the CSS file

function Lowvision() {
  return (

    <>
        {/* Banner Image */}
        <div className="lowvision-banner">  
            <img src="/lowvision.jpg" alt="LowVision Banner" className="lowvision-banner-image" />
          </div>


    <div className="lowvision-container">
      <h2>Low Vision</h2>
      <p>Some eye conditions cannot be treated with medication, surgery, or traditional corrective lenses. These conditions often affect older adults, particularly those who were once very active but now struggle with everyday tasks. While these challenges can be significant, special visual aids can greatly enhance their quality of life.</p>
      
      <p>After a comprehensive eye assessment, an optometrist will recommend the most suitable solution to improve a person's vision. We offer top-quality visual aids from Eschenbach, a renowned brand from Germany. Additionally, we provide more affordable options to cater to different needs.</p>
      
      <p>At Eye Care, we also offer <strong>REVITALvision</strong>, a cutting-edge program available in developed countries to enhance vision. This clinically proven, non-surgical therapy can improve visual sharpness by one or two lines on standard vision charts. The program trains the brain to see more clearly and involves daily sessions on a computer, lasting about 30 minutes, three times a week. It is a personalized, FDA-approved program that is professionally monitored for optimal results.</p>
    </div>

    </>
  )
}

export default Lowvision
